<template>
  <div class="row">
    <div class="col-xl-12">
      <container-headline
        v-if="$CONST('CONFIG').NIVEAULH != 'true'"
        class="col-xl-12"
        :headline="$t('global.qualifications')"
        :col="3"
      >
        <button class="btn btn-primary" @click="showQualifikationHinzufuegen">
          <font-awesome-icon icon="fa-regular fa-plus" />{{$t("global.addqualification")}}
        </button>
      </container-headline>

      <container-headline
        v-if="$CONST('CONFIG').NIVEAULH == 'true'"
        class="col-xl-12"
        headline="Niveau"
        :col="3"
      >
        <button
          class="btn btn-primary" @click="showQualifikationHinzufuegen"
          v-if="berechtigungen.m_geschaeftspartner.create"
        >
          <font-awesome-icon icon="fa-regular fa-plus" />{{$t("global.addqualification")}}
        </button>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block br-t-l-0">
          <div class="list-group">
            <div class="row px-3 py-2 text-bold" v-if="qualifikationen.length > 0">
              <div class="col-xl-1">{{ $t("global.edit") }}</div>
              <div class="col-xl-1">{{ $t("global.qualifications") }}</div>
              <div class="col-xl-2">{{ $t("global.level") }}</div>
              <div class="col-xl-1">{{ $t("global.date") }}</div>
              <div class="col-xl-2">{{ $t("global.city") }}</div>
              <div class="col-xl-5">{{ $t("global.comment") }}</div>
            </div>
            <qualifikation
              v-for="(q, indexQ) in qualifikationen"
              :key="q.id || q.key"
              :qualifikation="q"
              :index="indexQ"
              @deleteQualifikation="qualifikationDeleted"
              @updateQualifikation="showQualifikationAendern"
            ></qualifikation>

            <div
              class="text-center text-primary my-2"
              v-if="qualifikationen.length == 0"
            >
              <strong>{{ $t("global.noqualificationsavailable") }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <qualifikation-modal
      @qchanged="qualifikationAendern"
      @qcreated="qualifikationHinzufuegen"
    ></qualifikation-modal>
  </div>
</template>

<script>
import { uuidv4 } from "@/utils/Uuid";

import ContainerHeadline from "@/components/ContainerHeadline";

import Qualifikation from "@/components/Geschaeftspartner/Qualifikation";
import QualifikationModal from "@/components/Geschaeftspartner/QualifikationModal";

export default {
  components: {
    ContainerHeadline,
    Qualifikation,
    QualifikationModal,
  },
  props: {
    person: {
      type: String,
      required: true,
    },
    shown: {
      type: Boolean,
      required: false,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    initialQualifikationen: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      qualifikationen: [],
    };
  },
  watch: {
    initialQualifikationen(val) {
      this.qualifikationen = [...val];
    },
  },
  created() {
    this.qualifikationen = [...this.initialQualifikationen];
  },
  methods: {
    showQualifikationHinzufuegen() {
      this.$bus.$emit("qualifikation-modal-show", { id: null, delete: null });
    },

    showQualifikationAendern(index) {
      if (this.qualifikationen[index]) {
        this.$bus.$emit(
          "qualifikation-modal-show",
          this.qualifikationen[index]
        );
      }
    },

    qualifikationHinzufuegen(qualifikation) {
      qualifikation.key = uuidv4();
      this.qualifikationen.push(qualifikation);
      this.updateParent();
    },

    qualifikationAendern(updateQualifikation) {
      let pos = this.qualifikationen.findIndex(
        (q) => q.id === updateQualifikation.id
      );

      if (pos != -1) {
        this.$set(this.qualifikationen, pos, updateQualifikation);
        this.updateParent();
      }
    },

    qualifikationDeleted(indexQ) {
      if (this.qualifikationen[indexQ].id) {
        this.qualifikationen[indexQ].delete = true;
      } else {
        this.qualifikationen.splice(indexQ, 1);
      }

      this.updateParent();
    },

    updateParent() {
      this.$emit("updatequalifikationen", {
        qualifikationen: this.qualifikationen,
      });
    },
  },
};
</script>
